module.exports = __webpack_public_path__ + "img/tips.6e95a2a0.png";